if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector('[name=id]').disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = this.resolveCart();
            this.submitButton = this.querySelector('[type="submit"]');

            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

            this.hideErrors = this.dataset.hideErrors === 'true';
        }

        resolveCart() {
            const drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer;
            const notification = document.querySelector('cart-notification');
            if (notification && typeof notification.getSectionsToRender === 'function') return notification;
            return null;
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            const quickViewModal = document.querySelector('quick-view-modal');
            const findQuickViewEl = (el) => {
                return (quickViewModal && quickViewModal.querySelector(el)) ? quickViewModal.querySelector(el) : undefined;
            }
            const isQuickViewActive = (quickViewModal && quickViewModal.classList.contains('show'));
            const loader = isQuickViewActive ? findQuickViewEl('.js-quickview-loader') : document.querySelector('.js-product-loader');
            if (loader && window.Global && typeof window.Global.showLoader === 'function') window.Global.showLoader(loader);
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            // Re-resolve on submit — custom elements may not have been upgraded at constructor time
            this.cart = this.resolveCart();

            const formData = new FormData(this.form);
            if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                if (typeof this.cart.setActiveElement === 'function') {
                    this.cart.setActiveElement(document.activeElement);
                }
            }
            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then(async (response) => {
                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    }

                    // Await paired helpers (divan base, delivery, recycle) before cart UI / redirect
                    // so the cart page or drawer shows every line instantly.
                    if (typeof window.__sleepcoAfterMainCartAdd === 'function') {
                        try {
                            await window.__sleepcoAfterMainCartAdd(response);
                        } catch (e) {
                            console.error('[product-form] helper cart add failed', e);
                        }
                    }

                    if (!this.cart || typeof this.cart.renderContents !== 'function') {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    // Re-fetch cart sections after helpers so drawer HTML includes them
                    if (typeof this.cart.getSectionsToRender === 'function') {
                        try {
                            const sectionIds = this.cart.getSectionsToRender().map((section) => section.id).join(',');
                            if (sectionIds) {
                                const sections = await fetch(`/?sections=${sectionIds}`).then((r) => r.json());
                                response.sections = Object.assign({}, response.sections || {}, sections);
                            }
                        } catch (e) {
                            console.error('[product-form] cart section refresh failed', e);
                        }
                    }

                    try {
                        const modalEl = window.bootstrap5 && window.bootstrap5.Modal
                            ? window.bootstrap5.Modal.getInstance('quick-view-modal')
                            : null;
                        if (modalEl) modalEl.hide();
                    } catch (e) {}

                    const modalBasket = document.querySelector('cart-drawer');
                    if (modalBasket) {
                        modalBasket.classList.remove('translate-x-full');
                        const overlay = document.getElementById('CartDrawer-Overlay');
                        if (overlay) overlay.classList.remove('opacity-0', 'invisible');
                    }

                    if (!this.error)
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response
                        });
                    this.error = false;
                    this.cart.renderContents(response);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    if (loader && window.Global && typeof window.Global.hideLoader === 'function') window.Global.hideLoader(loader);
                });
        }

        handleErrorMessage(errorMessage = false) {
            if (this.hideErrors) return;

            this.errorMessageWrapper =
                this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

            this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

            if (errorMessage) {
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}
